module.exports = __webpack_public_path__ + "img/stop.8280e7aa.svg";